module.exports = __webpack_public_path__ + "static/img/card_3_2.4974631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_3_2.png
// module id = Y1Kd
// module chunks = 0